import { Response } from './../../types/LabelsResponse';

const BASE_URL = process.env.API_BASE_URL;
const PATH = '/cmm-lab/v1/labels/findByLanguages?';

type Params = {
  language: string;
  settingsId: string;
};

export const getLabels = (params: Params): Promise<Response> => {
  const filters = new URLSearchParams(params);
  return fetch(`${BASE_URL}${PATH}${filters}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
    .then((response) => response.json())
    .then((response) => response)
    .catch((error) => {
      throw new Error(error);
    });
};
